import DayDetailsCellRenderer from "./DayDetailsCellRenderer";

export default class LeaveTimeCellRenderer extends DayDetailsCellRenderer {
    constructor(cssBaseClass, cssTopBorderClass) {
        super(cssBaseClass, cssTopBorderClass);
    }

    buildContent(cell) {
        if (cell.getValue().time > 0)
            cell.getCellEl().innerHTML = "<img src='" + cell.getValue().leaveInfo.printIconPath + "' class='for-print-only leavePrintIcon'/>" + this.parseTime(
                cell.getValue().time);
        else
            cell.getCellEl().innerHTML = this.parseTime(cell.getValue().time);
    }

    addTooltip(cell) {
        let leaveInfo = cell.getValue();
        cell.getRow().getTable().getTooltipController().addLeaveTooltip(cell.getCellEl(),
            cell.getRow().getParentRow().getHeaderCell().getValue().id,
            cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date,
            leaveInfo,
            cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
    }
}




// WEBPACK FOOTER //
// ./web/js/locktable/renderers/LeaveTimeCellRenderer.js